import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { IWidgetControllerConfig } from '@wix/native-components-infra/dist/src/types/types';
import { Order } from '@wix/ambassador-ecom-v1-order/types';
import { NormalizedOrder } from '@wix/restaurants-normalizers';

import { getOrderInfo } from '../../services/orderService';
import { ORDERS_FULFILLMENT_STATUS } from '../../services/orderService/helpers';
import { createStorageProvider } from '../../utils/storageContext';
import { noop } from '../../utils/noop';
import { RequestStatus, wrapRequest } from '../../utils/wrapRequest';

interface OrderTrackingPageData {
  fitToContentHeight: boolean;
  order: Order | null;
  orderRequestStatus: RequestStatus;
  orderStatus: ORDERS_FULFILLMENT_STATUS | null;
  orderNormalized: NormalizedOrder | null;
}

interface OrderTrackingPageActions {
  fetchOrder: (orderId: string) => Promise<Order | undefined>;
}

export interface OrderTrackingPageStorage
  extends OrderTrackingPageData,
    OrderTrackingPageActions {}

const defaultOrderTrackingPageStorage: OrderTrackingPageStorage = {
  fitToContentHeight: true,
  order: null,
  orderRequestStatus: RequestStatus.DEFAULT,
  orderStatus: null,
  orderNormalized: null,
  fetchOrder: noop,
};

const { withStorageProvider, useStorage } = createStorageProvider(
  defaultOrderTrackingPageStorage,
);

const initOrderTrackingPageStorage = (
  flowAPI: ControllerFlowAPI,
  controllerConfig: IWidgetControllerConfig,
): OrderTrackingPageStorage => {
  return {
    ...defaultOrderTrackingPageStorage,
    fetchOrder: wrapRequest(
      flowAPI,
      getOrderInfo,
      'order',
      'orderRequestStatus',
    ),
  };
};

export const mockOrderInfo: NormalizedOrder = {
  contactName: 'John Doe',
  contactId: undefined,
  fulfillmentMethodType: 1,
  formattedDeliveryAddress: '123 Main Street, New York, US',
  formattedPickupAddress: '456 Pickup Ave, New York, US',
  formattedPrice: '$25.00',
  fulfillmentDateTimeFrom: new Date('2026-06-11T15:00:00'),
  fulfillmentDateTimeTo: new Date('2026-06-11T15:30:00'),
  isCanceled: false,
  isManualOrder: false,
  isPOSOrder: false,
  isPickupOrder: false,
  order: { number: '10000' } as NormalizedOrder['order'],
  restaurantsOrderStatus:
    'Pending' as NormalizedOrder['restaurantsOrderStatus'],
  totalItems: 2,
};

const mockOrderTrackingPageStorage = (
  flowAPI: ControllerFlowAPI,
  controllerConfig: IWidgetControllerConfig,
): OrderTrackingPageStorage => {
  const initiatedStorage = initOrderTrackingPageStorage(
    flowAPI,
    controllerConfig,
  );

  return {
    ...initiatedStorage,
    orderNormalized: mockOrderInfo,
    orderRequestStatus: RequestStatus.RESOLVED,
    orderStatus: ORDERS_FULFILLMENT_STATUS.Pending,
  };
};

export {
  initOrderTrackingPageStorage,
  mockOrderTrackingPageStorage,
  withStorageProvider as withOrderTrackingPageStorageProvider,
  useStorage as useOrderTrackingPageStorage,
};
